import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import { TabPanel as TabPanelInner } from "@similarweb/ui-components";

const { green, blue, carbon } = colorsPalettes;

export const LockIcon = styled(SWReactIcons)`
    height: 16px;
    width: 16px;
    margin-left: 12px;
    display: flex;
    svg path {
        fill: ${green.s100};
    }
`;

export const TabIcon = styled(SWReactIcons)<{ isSelected: boolean }>`
    height: 16px;
    width: 16px;
    margin-right: 12px;
    display: flex;

    svg path {
        fill: ${carbon[300]};
        fill: ${({ isSelected }) => (isSelected ? blue[400] : carbon[300])};
    }
`;

export const BuilderTabsWrapper = styled.div`
    height: 100%;
    .react-tabs {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
`;
const MARGIN = 24;

export const TabPanel = styled(TabPanelInner)`
    width: 100%;
    margin: ${MARGIN}px;
    margin-right: 0px;
    height: calc(100% - ${2 * MARGIN}px);
`;

export const TabPanelWrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
`;
